import { render } from "./deals-board.vue?vue&type=template&id=b8aafb80"
import script from "./deals-board.vue?vue&type=script&lang=js"
export * from "./deals-board.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__